import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../store/slices/currentUser";
import { getParameterByKey, updateParameter } from "../../../services/apiParameters";
import {
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  Typography,
  Alert,
  Dialog,
  DialogTitle,
  DialogActions,
  Divider,
  Container
} from "@mui/material";
import Spinner from "../../../components/layout/spinner";
import ModalMessages from "../../../components/layout/modal-messages";

const Parameters = () => {
  const user = useSelector(selectCurrentUser);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [parameterValue, setParameterValue] = useState("");
  const [parameterDesc, setParameterDesc] = useState("");
  const [errors, setErrors] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const hasAccess = user.roleId === 1 || user.roleId === 4;

  useEffect(() => {
    if (hasAccess) {
      loadParameter();
    }
  }, [hasAccess]);

  const loadParameter = async () => {
    setLoading(true);
    try {
      const response = await getParameterByKey("DEFAULT_USER_PASSWORD");
      if (response.data?.isValid) {
        setParameterValue(response.data.data.value);
        setParameterDesc(response.data.data.description);
      } else {
        setErrors(response.data?.errors || [{ errorMessage: "Error al cargar el parámetro" }]);
      }
    } catch (err) {
      setErrors([{ errorMessage: "Error de conexión" }]);
    }
    setLoading(false);
  };

  const handleSave = async () => {
    setSaving(true);
    setErrors([]);
    try {
      const response = await updateParameter({
        key: "DEFAULT_USER_PASSWORD",
        value: parameterValue
      });

      if (response.data?.isValid) {
        setOpenDialog(true);
      } else {
        setErrors(response.data?.errors || [{ errorMessage: "Error al guardar el parámetro" }]);
      }
    } catch (err) {
      setErrors([{ errorMessage: "Error de conexión" }]);
    }
    setSaving(false);
  };

  if (!hasAccess) {
    return (
      <Grid container pt="0px" spacing={2} sx={{ width: "100%", mb: 3 }}>
        <Grid item xs={12}>
          <Alert severity="error">Acceso denegado. No tiene permisos para ver esta pantalla.</Alert>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid
        container
        pt="0px"
        spacing={2}
        sx={{
          heigth: "auto",
          width: "auto",
          marginBottom: 3,
          marginTop: 0,
          paddingBottom: 22,
        }}
      >
        <Grid item xs={12}>
          <Card
            elevation={3}
            align="center"
            sx={{ heigth: "auto", width: "auto" }}
          >
            <CardContent>
              <Container fixed sx={{ pt: 3, pb: 3 }}>
                <Grid container spacing={3} sx={{ minWidth: 0 }}>
                  <Grid item xs={12} sx={{ textAlign: "start" }}>
                    <Typography
                      style={{ fontWeight: "bold", fontSize: 18 }}
                      align="left"
                    >
                      Parámetros del Sistema
                    </Typography>
                    <Divider
                      flexItem
                      sx={{ bgcolor: "secondary.light", mt: 1 }}
                    />
                  </Grid>

                  {loading ? (
                    <Grid item xs={12} align="center">
                      <Spinner />
                    </Grid>
                  ) : (
                    <>
                      <Grid item xs={12} md={6} sx={{ textAlign: "left" }}>
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                          {parameterDesc || "Contraseña predeterminada asignada en restablecimientos y nuevos usuarios"}
                        </Typography>
                        <TextField
                          fullWidth
                          size="small"
                          label="Contraseña Predeterminada"
                          variant="outlined"
                          value={parameterValue}
                          onChange={(e) => setParameterValue(e.target.value)}
                          disabled={saving}
                          sx={{ mb: 3 }}
                        />
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => setOpenConfirmDialog(true)}
                          disabled={saving || !parameterValue.trim()}
                          sx={{ position: "relative" }}
                        >
                          {saving && <Spinner color="inherit" />}
                          <span style={{ opacity: saving ? 0 : 1 }}>GUARDAR CAMBIOS</span>
                        </Button>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Container>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {errors.length > 0 && (
        <ModalMessages errors={errors} handleClose={() => setErrors([])} />
      )}

      {openConfirmDialog && (
        <Dialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"¿Confirma restablecer la contraseña?"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => setOpenConfirmDialog(false)}>Cancelar</Button>
            <Button
              onClick={() => {
                setOpenConfirmDialog(false);
                handleSave();
              }}
              autoFocus
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {openDialog && (
        <Dialog
          open={openDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"La contraseña ha sido restablecida"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)} autoFocus>
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default Parameters;
